import React, { useContext, useEffect, useState } from 'react';
import { IntroPlaybackContext } from './IntroPlayback';
import { useLocation } from 'react-router-dom';
import ResumeReading from './ResumeReading';
import HomeBgm from './HomeBgm';
import './FloatingTools.css';

export default function FloatingTools() {
  const { active: introActive } = useContext(IntroPlaybackContext);
  const { pathname, key } = useLocation();
  const [expanded, setExpanded] = useState(false);
  const isCompact = pathname !== '/';
  useEffect(() => { setExpanded(false); }, [key]);
  return (
    <div inert={introActive ? '' : undefined} className={`floating-tools${isCompact ? ' floating-tools--reading' : ''}${expanded ? ' floating-tools--expanded' : ''}`}>
      <ResumeReading />
      <div id="floating-bgm-panel" className="floating-tools__bgm"><HomeBgm /></div>
      {isCompact && <button
          type="button"
          className="floating-tools__toggle"
          aria-label={expanded ? 'BGM操作パネルを閉じる' : 'BGM操作パネルを開く'}
          aria-expanded={expanded}
          aria-controls="floating-bgm-panel"
          onClick={() => setExpanded((value) => !value)}
        >{expanded ? '閉じる ×' : '♪ BGM'}</button>}
    </div>
  );
}
